export default {"src":"/_next/static/media/account.d342a73c.svg","height":30,"width":30};